import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { languageReducer } from './language.reducer';
import { LanguageEffects } from './language.effects';

/**
 * Language feature state module
 * Encapsulates all language-related state management
 */
@NgModule({
  imports: [
    StoreModule.forFeature('language', languageReducer),
    EffectsModule.forFeature([LanguageEffects])
  ]
})
export class LanguageStateModule {}
